import React, { Component } from 'react';
import { Router, Route, Redirect, browserHistory } from 'react-router';
import Layout from './components/layout';
import DataVisualisation from './components/data_visualisation';
import './App.css';

class App extends Component {
  render () {
    return (
      <Router history={browserHistory}>
        <Redirect from="/infographics/elections" to="/infographics/elections/presidential-candidates" />
        <Route path='/infographics/elections' component={Layout}>
          <Route path=':dataset(/:month)(/:wave)' component={DataVisualisation} />
        </Route>
      </Router>
    )
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/